<template>
  <b-modal
    ref="costModal"
    :title="$t('diagnosis.labels.costInfo')"
    centered
    hide-footer
    modal-class="cost-modal"
  >
    <div class="scroll-unit">
      <b-row class="mx-1 sticky">
        <b-col>
          <div class="header p-1">
            <b-row class="px-2">
              <b-col cols="2">
                <span>{{ $tc('global.sample',2) }}</span>
              </b-col>
              <b-col>
                <span>{{ $t('diagnosis.modals.billableConcepts') }}</span>
              </b-col>
              <b-col>
                <span>{{ $t('diagnosis.modals.guarantor') }}</span>
              </b-col>
              <b-col cols="2">
                <span>{{ $t('diagnosis.modals.price') }}</span>
              </b-col>
              <b-col cols="2">
                <span>{{ $t('diagnosis.modals.rate') }}</span>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
      <b-row
        v-for="(costUnit, index) in costUnits"
        :key="index"
        class="mx-1 mt-1"
      >
        <b-col>
          <div class="unit-row p-1">
            <b-row class="px-2">
              <b-col cols="2">
                <span class="main">{{ costUnit.sample }}</span>
              </b-col>
              <b-col>
                <span>{{ costUnit.billableConcept }}</span>
              </b-col>
              <b-col>
                <span>{{ costUnit.guarantor }}</span>
              </b-col>
              <b-col cols="2">
                <span>{{ costUnit.price }}</span>
              </b-col>
              <b-col cols="2">
                <span>{{ costUnit.rate }}</span>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </div>
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-6 text-left">
          <b-button
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
    name: 'CostModal',
    props: {
        title: String
    },
    data() {
        return {
            // Datos mockeados
            costUnits: [
                { sample: 'A', guarantor: 'Servicio Andaluz de Salud', billableConcept: 'URV de tipo técnica', price: 15, rate: 5 },
                { sample: 'B', guarantor: 'Servicio Andaluz de Salud', billableConcept: 'URV de tipo técnica', price: 15, rate: 5 },
                { sample: 'C', guarantor: 'Servicio Andaluz de Salud', billableConcept: 'URV de tipo técnica', price: 15, rate: 5 },
                { sample: 'D', guarantor: 'Servicio Andaluz de Salud', billableConcept: 'URV de tipo técnica', price: 15, rate: 5 },
                { sample: 'E', guarantor: 'Servicio Andaluz de Salud', billableConcept: 'URV de tipo técnica', price: 15, rate: 5 },
                { sample: 'F', guarantor: 'Servicio Andaluz de Salud', billableConcept: 'URV de tipo técnica', price: 15, rate: 5 }
            ]
        }
    },
    methods: {
        show() {
            this.$refs.costModal.show()
        },
        hide() {
            this.$refs.costModal.hide()
        }
    }
}
</script>

<style lang="scss">
.cost-modal .main{
  color: vt-color(primary) !important;
}

.cost-modal .modal-dialog {
  max-width: 55% !important;
}

.cost-modal .modal-body{
  padding-bottom: 40px;
}

.cost-modal .header{
  background: vt-color(light-grey-alt);
  border-radius: 3px;
}

.cost-modal .header span{
  text-transform: uppercase;
  font-size: font-size(small);
  color: vt-color(dark-text);
}

.cost-modal .unit-row{
  border-bottom: 1px solid vt-color(base-text, .7);
  transition: .4s;
  background-color: vt-color(primary, 1);
  font-size: font-size(very-small);
}

.cost-modal .unit-row:hover{
  background-color: vt-color(primary, .95);
}

.cost-modal .scroll-unit{
  min-height: 20vh;
  max-height: 30vh;
  overflow-y: auto;
}

.cost-modal .sticky {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 2;
}

@media (max-width: 1300px) {
  .cost-modal .modal-dialog {
    max-width: 70% !important;
  }
}

@media only screen and (max-width: 1366px) and (min-width: 1360px) {
  .cost-modal .modal-dialog {
    max-width: 70% !important;
  }
}

</style>
